


















import { PropType } from 'vue'

export default {
  name: 'NewUiSwitcher',
  props: {
    type: {
      type: [Number, String] as PropType<'1' | '2' | 1 | 2>,
      default: '1'
    },
    checked: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipData: {
      required: false,
      default: null
    }
  },
  methods: {
    handleChange (): void {
      !this.disabled && this.$emit('change', !this.checked)
    }
  }
}
